import React, { useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import ClassSidebar from "../components/ClassSidebar";
import Flashcards from "../components/Flashcards";
import PracticeExams from "../components/PracticeExams";
import ActiveRecall from "../components/ActiveRecall";
import ScoreCard from "../components/ScoreCard";
import "../components/LayoutGrid.css";
import ScoreCards from "../components/ScoreCard";


const MainPage = () => {
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [selectedUnitId, setSelectedUnitId] = useState(null);
  const [selectedUnitName, setSelectedUnitName] = useState("");

  const auth = getAuth();
  const userId = "userId"

  useEffect(() => {
    console.log("👤 Auth state:", userId);
  }, [userId]);



  return (
    <div className="main-layout">
      <aside className="left-column">
        <ClassSidebar
          userId={userId}
          selectedClassId={selectedClassId}
          selectedUnitId={selectedUnitId}
          onSelectClass={setSelectedClassId}
          onSelectUnit={(unitId, unitName) => {
            setSelectedUnitId(unitId);
            setSelectedUnitName(unitName);
          }}

        />
      </aside>

      <main className="center-column">
        <Flashcards
          userId={userId}
          selectedClassId={selectedClassId}
          selectedUnitId={selectedUnitId}
          selectedUnitName={selectedUnitName}
        />

        <PracticeExams
          selectedClassId={selectedClassId}
          selectedUnitId={selectedUnitId}
          selectedUnitName={selectedUnitName}   
          userId={userId}
        />

        <ActiveRecall
          selectedClassId={selectedClassId}
          selectedUnitId={selectedUnitId}
          selectedUnitName={selectedUnitName}
          userId={userId}
        />

      </main>

      

    </div>
  );
};

export default MainPage;
